import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import { authApi } from '@/api'

Vue.use(Vuex)

// 安全解析 localStorage 中的 userInfo，数据损坏时返回空对象，避免应用启动白屏
function safeParseUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
  } catch (e) {
    return {}
  }
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: safeParseUserInfo(),
    sidebar: {
      opened: true
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebar.opened = !state.sidebar.opened
    },
    CLEAR_USER(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    async login({ commit }, userInfo) {
      try {
        const response = await authApi.login(userInfo)
        const { data } = response
        commit('SET_TOKEN', data.token)

        const roleCodes = Array.isArray(data.roleCodes) ? data.roleCodes : []
        const roleCodeNum = roleCodes.includes('super') ? 1 : roleCodes.includes('b_company') ? 2 : 0
        let currentUser = {
          id: data.adminId,
          username: data.username,
          status: data.status,
          roleCodes,
          roleCodeNum
        }

        // 优先使用登录返回的权限信息；没有则再请求 getOauthInfo
        const oauthInfo = data.adminUserDTO || (await authApi.getUserInfo()).data || {}
        currentUser = {
          ...currentUser,
          ...oauthInfo,
          roleCodes,
          roleCodeNum
        }
        commit('SET_USER_INFO', currentUser)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async logout({ commit }) {
      try {
        await authApi.logout()
      } catch (error) {
        console.warn('登出接口暂不可用，执行本地登出:', error)
      }
      commit('CLEAR_USER')
      router.push('/login')
    },
    async getUserInfo({ commit }) {
      try {
        const response = await authApi.getUserInfo()
        const localUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        const userInfo = {
          ...localUserInfo,
          ...(response.data || {})
        }
        let roleCodeNum = 0
        if (Array.isArray(userInfo.roleCodes)) {
          roleCodeNum = userInfo.roleCodes.includes('super') ? 1 : userInfo.roleCodes.includes('b_company') ? 2 : 0
        }
        commit('SET_USER_INFO', { ...userInfo, roleCodeNum })
        return Promise.resolve(response)
      } catch (error) {
        console.warn('获取用户信息接口暂不可用，使用本地数据:', error)
        const localUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        let roleCodeNum = 0
        if (localUserInfo.roleCodes) {
          roleCodeNum = localUserInfo.roleCodes.includes('super') ? 1 : localUserInfo.roleCodes.includes('b_company') ? 2 : 0
        }
        commit('SET_USER_INFO', { ...localUserInfo, roleCodeNum })
        return Promise.resolve({ data: localUserInfo })
      }
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    sidebar: state => state.sidebar
  }
})